
export const environment = {
  production: true,
  name: "Production",

  auth0: {
    domain: 'transnetyx-prod.us.auth0.com',
    clientId: 'idIHgWZpTUBcPa3ByJe49Jvf2axw92Ap',
    audience: 'Ops_SnpViewer_API',
    scope: '',
    redirectUri: `https://snpviewer.transnetyx.com`
  },

  apiUrl: "https://api.transnetyx.com/snpviewer/"
};
